import React from "react";
import StoryImage from "../../../utils/StoryImage";
import ArrowButton from "../../../utils/button/ArrowButton";
import CustomModal from "../../../utils/modal/CustomModal";

export default function Book({
  story,
  setStory,
  index,
  setIndex,
  showFinalModal,
  setShowFinalModal,
  handleChangeBackground,
  user_id,
  character_job_id,
  storyPrompt,
  storyId,
}) {
  const [isEditing, setIsEditing] = React.useState(false);
  const [editValue, setEditValue] = React.useState("");

  const handleButtonClick = (direction) => {
    if (direction === "right") {
      if (story.length === index + 1) {
        setShowFinalModal(true);
      }
      setIndex((prev) => prev + 1);
    } else if (direction === "left") {
      setIndex((prev) => prev - 1);
    }
    setIsEditing(false); // 페이지 이동 시 편집 모드 해제
  };

  const handleEditToggle = () => {
    if (!isEditing) {
      setEditValue(story[index]?.page_content || "");
    }
    setIsEditing(!isEditing);
  };

  const handleSave = () => {
    const newStory = [...story];
    newStory[index] = { ...newStory[index], page_content: editValue };
    setStory(newStory);
    setIsEditing(false);
  };

  return (
    <div className="result-wrap">
      {story[index] ? (
        <div className="background">
          <StoryImage src={story[index].image_url ?? ""} alt="bg-img" />
        </div>
      ) : (
        <div>배경 이미지 불러오는 중...</div>
      )}
      <div className="captions">
        <button className="modify-btn" onClick={handleEditToggle}>
          <figure>
            <img src={"/images/utils/button/cont-modi-btn.svg"} alt="" />
          </figure>
        </button>
        {isEditing ? (
          <div className="edit-box">
            <textarea
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              className="edit-textarea"
            />
            <button onClick={handleSave} className="save-btn">
              저장하기
            </button>
          </div>
        ) : (
          <p>{story[index]?.page_content}</p>
        )}
      </div>
      <div className="choice-btns">
        <div className="right-btn">
          <div className="ballon right">" 그림을 바꾸고 싶나요? "</div>
          <div
            className="btn open-image-modal"
            onClick={() => handleChangeBackground()}
          >
            <figure>
              <img
                src="/images/utils/button/change-icon-button.svg"
                alt="이미지 바꾸기 아이콘"
              />
            </figure>
            <span>이미지 바꾸기</span>
          </div>
        </div>
      </div>
      {!showFinalModal && (
        <>
          {index !== 0 && (
            <ArrowButton
              onClick={() => handleButtonClick("left")}
              direction="left"
              className="story-btn prev-btn"
            />
          )}
          <ArrowButton
            onClick={() => handleButtonClick("right")}
            direction="right"
            className="story-btn next-btn"
          />
        </>
      )}
      {showFinalModal && (
        <>
          <CustomModal
            contentList={story}
            user_id={user_id}
            character_job_id={character_job_id}
            storyPrompt={storyPrompt}
            storyId={storyId}
            story={story}
            onClose={() => {
              setShowFinalModal(false);
              setIndex((prev) => prev - 1);
            }}
          />
        </>
      )}
    </div>
  );
}
